/** @jsxImportSource theme-ui @jsxRuntime classic */
import { graphql } from 'gatsby';
// import { useLocation } from '@reach/router';
import React from 'react';

import { BuyTicketsApp } from '../../components/BuyTickets/BuyTicketsApp';
import { Layout } from '../../layouts';
// import { useNetlifyBotCheck } from '../../utils';
import { Oljs } from '../../components/Oljs';

import type { PageConfig } from '../../PageConfig';

export const pageConfig: PageConfig = {
  theme: 'Rock Center',
  logo: 'Rockefeller Center',
};

export default function BuyTickets(): React.JSX.Element {
  // Serve bots a flattened version of the page
  // const location = useLocation();
  // useNetlifyBotCheck(location.href);

  return (
    <Layout sx={{ marginTop: [0, 5] }}>
      <Oljs />
      <BuyTicketsApp />
    </Layout>
  );
}

export const query = graphql`
  query BuyTickets {
    meta: dataJson(jsonId: { eq: "buy-tickets" }) {
      meta {
        title
        description
      }
    }
    alert: dataJson(jsonId: { eq: "buy-tickets" }) {
      alert {
        title
      }
    }
    allSanityTicketCategory(filter: { i18nLang: { in: ["en-US", null] } }) {
      nodes {
        availableFeatures
        description: _rawDescription(resolveReferences: { maxDepth: 10 })
        enabled
        id: _id
        order
        slug {
          current
        }
        tickets {
          description: _rawDescription(resolveReferences: { maxDepth: 10 })
          id: _key
          image {
            alt
            asset {
              gatsbyImageData(layout: CONSTRAINED, width: 661, height: 443)
            }
          }
          linkOverrides {
            buyTicketsPage
            buyTicketsPageBuyTickets
          }
          includedFeatures
          price
          secondaryUrl {
            caption
            url
          }
          tertiaryUrl {
            caption
            url
          }
          title
          url {
            caption
            url
          }
        }
        title
      }
    }
  }
`;
